module.exports = __webpack_public_path__ + "static/ChatAnalytics-b8eaa824f5c403e7c00ca9d43aa3793e.png";